import { SET_VISIBILITY_VIDEO } from "../type";

const initState = {
    videoShow: true
}

function VideoManager(state = initState, action) {
    switch (action.type) {
        case SET_VISIBILITY_VIDEO:
            return {
                ...state,
                videoShow: !state.videoShow
            } 
        default:
            return state;
    }
}

export default VideoManager;